import { render, staticRenderFns } from "./LearningRequest.vue?vue&type=template&id=4d45a602&scoped=true&"
import script from "./LearningRequest.vue?vue&type=script&lang=ts&"
export * from "./LearningRequest.vue?vue&type=script&lang=ts&"
import style0 from "./LearningRequest.vue?vue&type=style&index=0&id=4d45a602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45a602",
  null
  
)

export default component.exports